import { GekdCode } from '../types';

/**
 * Статичный справочник ГЭКД кодов
 * ГЭКД - Государственная Единая Классификация Документов
 */
export const MOCK_GEKD_CODES: GekdCode[] = [
  {
    id: '1',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '100',
    name: 'Накладная'
  },
  {
    id: '2',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '101',
    name: 'Товарная накладная'
  },
  {
    id: '3',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '102',
    name: 'Товарно-транспортная накладная'
  },
  {
    id: '4',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '200',
    name: 'Акт приема-передачи'
  },
  {
    id: '5',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '201',
    name: 'Акт выполненных работ'
  },
  {
    id: '6',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '202',
    name: 'Акт оказанных услуг'
  },
  {
    id: '7',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '300',
    name: 'Счет-фактура'
  },
  {
    id: '8',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '301',
    name: 'Счет на оплату'
  },
  {
    id: '9',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '400',
    name: 'Платежное поручение'
  },
  {
    id: '10',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '401',
    name: 'Платежное требование'
  },
  {
    id: '11',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '500',
    name: 'Кассовый чек'
  },
  {
    id: '12',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '501',
    name: 'Приходный кассовый ордер'
  },
  {
    id: '13',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '502',
    name: 'Расходный кассовый ордер'
  },
  {
    id: '14',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '600',
    name: 'Товарный чек'
  },
  {
    id: '15',
    created_at: new Date().toISOString(),
    is_deleted: false,
    code: '700',
    name: 'Договор'
  }
];
